import { AutoComplete } from 'antd';
import styled from 'styled-components';

export default styled(AutoComplete)`
	// Add your styles here
`;
